import { Control, useFieldArray } from "react-hook-form";
import { generateUniqueId } from "utils/helpers";
import useTranslation from "utils/hooks/useTranslation";
import { CircuitItem } from "./CircuitItem";

export interface CircuitItemFields {
  id: string;
  name?: string;
  underfloorHeating?: "yes" | "no" | null;
  type?: number;
  puissance?: number | null;
  startTemperature?: number | null;
  delta_t?: number | null;
  surpuissance?: number | null;
}

export type CircuitListData = CircuitItemFields[];

interface CircuitListProps {
  name: string;
  control: Control<any>;
  maxCount?: number;
  allData?: any;
  service?: string;
}

export const CircuitList: React.FC<CircuitListProps> = ({
  name,
  control,
  maxCount,
  allData,
  service,
}) => {
  const { t } = useTranslation();

  const { fields, append, remove } = useFieldArray({ name, control });

  const addItem = () => {
    append({
      id: generateUniqueId(),
      name: t("FO_SIMULATION_CIRCUIT" + (fields.length + 1)),
      type: null,
      underfloorHeating: "no",
      startTemperature: null,
      puissance: null,
      delta_t: null,
      surpuissance: null,
    });
  };
  return (
    <group data-gap="30">
      {fields?.map((item, index) => {
        return (
          item.id && (
            <CircuitItem
              onDelete={() => remove(index)}
              key={item.id}
              name={name + `[${index}]`}
              control={control}
              allData={allData}
              index={index}
              service={service}
            />
          )
        );
      })}
      {(maxCount === undefined || fields?.length < maxCount) && (
        <group
          onClick={addItem}
          data-gap="10"
          data-space="20"
          data-radius="special"
          data-length="480"
          data-border-color="border-color"
          data-border="dashed"
          data-interactive=""
          data-cursor="pointer"
        >
          <group data-gap="20" data-justify="center" data-align="center">
            <group data-width="auto" data-gap="10">
              <icon>add</icon>
              <text data-text-size="large" data-color="grey-color-dark">
                {t("FO_SIMULATION_ADD_CIRCUIT")}
              </text>
            </group>
          </group>
        </group>
      )}
    </group>
  );
};
